<template>
  <div class="menu-wrapper">
    <template v-for="item in routes" v-if="!hidePage(item)">
      <router-link v-if="!item.hidden&&item.children&&item.children.length===1" :to="item.path+'/'+item.children[0].path" :key="item.children[0].name">
        <el-menu-item :index="item.path+'/'+item.children[0].path" class='submenu-title-noDropdown'>
          <svg-icon v-if="item.children[0].meta&&item.children[0].meta.icon" :icon-class="item.children[0].meta.icon"></svg-icon>
          <span v-if="item.children[0].meta&&item.children[0].meta.title">
            <template v-if="(userId == 653 || userId == 1016 || userId == 2990) && item.children[0].meta.title == 'CPA广告'">非标广告</template>
            <template v-else>{{item.children[0].meta.title}}</template>
        </span>
        </el-menu-item>
      </router-link>
      <el-submenu v-if="!item.hidden&&item.children&&item.children.length>1" :index="item.name||item.path" :key="item.name">
        <template slot="title">
          <router-link :to="item.path">
            <svg-icon v-if="item.meta&&item.meta.icon" :icon-class="item.meta.icon"></svg-icon>
            <span v-if="item.meta&&item.meta.title">{{item.meta.title}}</span>
          </router-link>
        </template>
        <template v-if="!child.hidden" v-for="child in item.children">
          <sidebar-item class="nest-menu" v-if="child.children&&child.children.length>0" :routes="[child]" :key="child.path"></sidebar-item>
          <router-link v-else :to="item.path+'/'+child.path" :key="child.name">
            <el-menu-item :index="item.path+'/'+child.path">
              <svg-icon v-if="child.meta&&child.meta.icon" :icon-class="child.meta.icon"></svg-icon>
              <span v-if="child.meta&&child.meta.title">{{child.meta.title}}</span>
            </el-menu-item>
          </router-link>
        </template>
      </el-submenu>
    </template>
  </div>
</template>
<script>
import { getToken } from '@/utils/auth'

export default {
  name: 'SidebarItem',
  data() {
    return {
      userId: JSON.parse(getToken()).userId,
      // 自建站广告主ID白名单
      diysiteIds: [132, 133, 179, 256, 472, 476, 526, 631, 675, 696, 704, 1109, 1131, 1143, 1152, 1156, 1159, 1186, 1225, 1279, 1287, 1288, 1301, 1312, 1314, 1363, 1364, 1383, 1437, 1440, 1445, 1448, 1455, 1458, 1464, 1496, 1580, 1675, 1680, 1732, 1757, 1788, 1795, 1842, 1843, 1844, 1959, 2057, 2060, 2097, 2103, 2129, 2130, 2131, 2148, 2176, 2206, 2301, 2360, 2361, 2365, 2366, 2367, 2368, 2377, 2395, 2397, 2402, 2407, 2416, 2425, 2436, 2437, 2438, 2442, 2443, 2472, 2996]
    }
  },
  props: {
    routes: {
      type: Array
    }
  },
//   computed(){
//        ownSite:function(){
//                     return this.$store.getters.ownSite;
//             }
//   },
  created() {
    this.userId = JSON.parse(getToken()).userId;
    // console.log("++++++++++++++++" + this.userId);
  },
  methods: {
    hidePage(item) {
      if (item.name == 'diysite') {
          let ownSite=window.localStorage.getItem('ownSite');
          if(ownSite == 'false'){
              return true;
          }else{
              return false;
          }

        //   return !item.isOwnSite;
        // return !(this.diysiteIds.indexOf(this.userId) > -1);
      }
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/SidebarItem.vue